import React from "react";
import Components from "../services/ComponentsV";
function ViewComponent({
  name,
  object,
  index,
  useVals,
  setTabs,
  active,
  setTabsImage,
  setObject2,
  ISReport
}) {
  React.useEffect(() => {
  });



  if (name !== "StructureImages" && ISReport != 9) {
    return (




      <div class="card-header" >
        <h5 class="mb-0">
          <button type="button"
            class="btn btn-link  w-100 d-flex justify-content-between align-items-center collapsed"
          >

            <div class="left">

              <span>  {name}</span>
            </div>


          </button>
        </h5>

        {name !== "StructureImages" ?
          (
            <div
              id={`collapse${index}`}
              class="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >

              {(name == "Building Cost Breakdown") ? (
                <>
                  <div class="row justify-content-end" style={{ marginBottom: "2%" }}>
                    <div class="col-xl-8 col-lg-8 mt-3">
                      <div class="table-outer">
                        {/* {active=="Single Family" ?( <div class="row input-box1 ">

<div class="col-md-3"></div>
<div class="col-md-2"><label class="d-block">Per sqft </label></div>
<div class="col-md-3"><label class="d-block">Per Lot</label></div>
<div class="col-md-3"><label class="d-block">Project</label></div>
</div>):( active=="Condo" || active=="Apartment"?( <div class="row input-box1 ">

<div class="col-md-3"></div>
<div class="col-md-2"><label class="d-block">Per sqft </label></div>
<div class="col-md-3"><label class="d-block">Per Unit</label></div>
<div class="col-md-3"><label class="d-block">Project</label></div>
</div>):(<div class="row input-box1 ">

<div class="col-md-3"></div>
<div class="col-md-3"><label class="d-block">Per sqft </label></div>
<div class="col-md-3" style={{marginLeft:"-6%"}}><label class="d-block">Per Home</label></div>
<div class="col-md-3"><label class="d-block">Project</label></div>
</div>))} */}

                        <div class="row mytable " style={{ width: "100%" }}>

                          {object &&
                            object[name].map((item) => Components(item, object[name], setObject2, useVals, 0, object))}

                        </div>



                      </div>
                    </div>

                    <div class="col-xl-2 col-lg-4 text-center " style={{ marginTop: "7%" }}>


                    </div>
                  </div>
                  <br /><br />
                </>
              ) : (
                (name == "Sales Cost Breakdown" || name == "Proforma Breakdown" || name == "Land Analysis") ? (

                  <div class="row justify-content-end" style={{ marginBottom: "2%" }}>
                    <div class="col-xl-8 col-lg-8 mt-3">
                      <div class="table-outer">


                        <div class="row mytable " style={{ width: "107%" }}>

                          {object &&
                            object[name].map((item) => Components(item, object[name], setObject2, useVals, 0, object))}

                        </div>



                      </div>
                    </div>

                    <div class="col-xl-2 col-lg-4 text-center " style={{ marginTop: "7%" }}>


                    </div>
                  </div>


                ) : (
                  <div class="row justify-content-end" style={{ marginBottom: "2%" }}>
                    {name == "Site Potential" ? (
                      <>
                        { }
                        <div class="col-xl-8 col-lg-8">
                          <form class="input-box ">
                            {object && object[name].map((item) => Components(item, object[name], setObject2, useVals, 0, object))}
                          </form>
                          <div class="table-outer">
                            <div class="row mytable " style={{ width: "107%" }}>
                              {object && object[name].map((item) => Components(item, object[name], setObject2, useVals, 1, object))}
                            </div>
                          </div>
                        </div>



                        <div class="col-xl-2 col-lg-2 text-center " >


                        </div>
                      </>) :
                      (<> <div class="col-xl-10 col-lg-10"> <form class="input-box1 ">
                        <div class="row financingdiv" id="loan">
                          {object &&
                            object[name].map((item) => Components(item, object[name], setObject2, useVals, 0, object))}
                        </div>
                        <div class="row financingdiv" id="cons">
                          {object &&
                            object[name].map((item) => Components(item, object[name], setObject2, useVals, 1, object))}
                        </div>
                        <div class="row financingdiv" id="ext">
                          {object &&
                            object[name].map((item) => Components(item, object[name], setObject2, useVals, 2, object))}
                        </div>
                        <div class="row " style={{ width: "100%" }}>
                          {object &&
                            object[name].map((item) => Components(item, object[name], setObject2, useVals, 3, object))}
                        </div>
                      </form> </div> <div class="col-xl-1 col-lg-1 text-center " >


                        </div></>)}

                  </div>
                )
              )
              }

            </div>

          ) : (
            <div style={{ margin: "3%" }} class="row">

            </div>
          )}
      </div>);
  }

  else if (name !== "StructureImages" && ISReport == 9) {
    return (
      <div class="row " id="TopSummary" >
        <div class="col-xl-12 col-lg-12">
          <div class="table-outer">


            <div class="row mytable " style={{ width: "107%" }}>

              {object &&
                object[name].map((item) => Components(item, object[name], setObject2, useVals, 9, object))}

            </div>



          </div>
        </div>

        <div class="col-xl-2 col-lg-4 text-center " style={{ marginTop: "7%" }}>


        </div>
      </div>
    );
  }


  else {
    return (<></>);
  }
}

export default ViewComponent;
